import * as React from 'react';
import { Button } from 'react-bootstrap';

interface IProps {
    onDecline: () => void;
    onVerify: () => void;
    declineDisabled?: boolean;
    verifyDisabled?: boolean;
    declineTitle?: string;
    verifyTitle?: string;
}

const VerifyIncomeActions = (props: IProps) => {
    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: 15, paddingBottom: 15 }}>
            <Button
                bsStyle='primary btn-danger'
                onClick={props.onDecline}
                disabled={props.declineDisabled}
                title={props.declineTitle}
                style={{ width: 110 }}>
                Decline
            </Button>
            <Button
                bsStyle='success'
                onClick={props.onVerify}
                disabled={props.verifyDisabled}
                title={props.verifyTitle}
                style={{ width: 110 }}>
                Verify
            </Button>
        </div>
    );
};

export default VerifyIncomeActions;
